var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "25px",
    viewBox: "0 0 101 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch Beta.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 23.2096023 0 23.2096023 25 0 25"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(-25.000000, -19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(25.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-dark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6973864,23.7215909 C7.57835227,23.7215909 2.61784091,18.6340909 2.61784091,12.3579545 C2.61784091,6.08210227 7.57835227,0.994318182 13.6973864,0.994318182 C16.8922727,0.994318182 19.7692614,2.38295455 21.7914205,4.60170455 C19.54,1.79375 16.1147159,0 12.2769318,0 C5.49653409,0 -5.68181818e-05,5.59630682 -5.68181818e-05,12.5 C-5.68181818e-05,19.4036932 5.49653409,25 12.2769318,25 C17.0459659,25 21.1766477,22.2295455 23.2096023,18.1852273 C21.274375,21.5011364 17.7394318,23.7215909 13.6973864,23.7215909",
    id: "Fill-1",
    fill: "#093454",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#09C7AD",
    points: "8.98505682 10.4931818 12.391875 10.4931818 12.9989773 11.1 11.0458523 13.053125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2769318,2.91775568 C14.8902841,2.91775568 17.2593182,3.95838068 18.9982386,5.64616477 L10.2382955,14.3700284 L7.06613636,10.4933239 L3.62011364,10.4933239 L10.0422727,18.4035511 L20.6596023,7.7859375 C20.6607386,7.78792614 20.6615909,7.78963068 20.6627273,7.79133523 L22.7064773,5.74730114 C20.69625,2.87059659 17.4115909,0.994176136 13.6973864,0.994176136 C7.57835227,0.994176136 2.61784091,6.08196023 2.61784091,12.3578125 C2.61784091,12.397017 2.62039773,12.4353693 2.62068182,12.4742898 C2.68176136,7.18622159 6.98034091,2.91775568 12.2769318,2.91775568",
    id: "Fill-6",
    fill: "#09C7AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3347159,6.75409091 L21.2020455,8.88704545 C21.2020455,8.88704545 21.2020455,8.88732955 21.2020455,8.88732955 L20.8080114,9.28107955 L17.8028977,12.2859091 L17.8009091,12.2839205 L13.6975,16.3813636 L15.4071591,18.4035227 L21.9171023,12.0055114 C21.9284659,12.1984091 21.9361364,12.3921591 21.9361364,12.5876136 C21.9361364,17.9282386 17.6114205,22.2575 12.2770455,22.2575 C7.78329545,22.2575 4.00659091,19.1853409 2.92761364,15.0242614 C4.09778409,20.0134659 8.47420455,23.7217045 13.6975,23.7217045 C19.8165341,23.7217045 24.7770455,18.6339205 24.7770455,12.3580682 C24.7770455,10.3194318 24.2511932,8.40835227 23.3347159,6.75409091",
    id: "Fill-8",
    fill: "#03AC95"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Text-dark",
    transform: "translate(31.000000, 6.000000)",
    fill: "#2F413E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    points: "0.748502836 0.370027273 4.67211008 12.2944545 6.9031675 12.2944545 9.44199223 4.6384 12.0319411 12.2944545 14.2374365 12.2944545 18.1354816 0.370027273 15.4173816 0.370027273 13.1604213 8.26610909 10.5701316 0.343436364 8.33907414 0.343436364 5.87727644 8.15974545 3.47103364 0.363645455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9184071,7.22445455 L22.3601078,3.59000909 L23.8021493,7.22445455 L20.9184071,7.22445455 Z M23.6082184,0.359390909 L21.2234478,0.359390909 L16.2879234,12.3008364 L18.921839,12.3295545 L19.9201231,9.70485455 L24.7728263,9.70485455 L25.7428216,12.2717636 L28.46024,12.2717636 L23.6082184,0.359390909 Z",
    id: "Fill-12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    points: "29.6527617 0.359461818 29.6527617 12.3296255 37.915445 12.3296255 37.915445 9.90666182 32.2311224 9.90666182 32.2311224 0.359461818"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    points: "39.6346476 0.359461818 39.6346476 12.3296255 47.8976717 12.3296255 47.8976717 9.90666182 42.2133491 9.90666182 42.2133491 0.359461818"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    points: "49.3395769 0.359461818 49.3395769 12.3009073 58.0463586 12.3009073 58.0463586 9.90666182 51.8903306 9.90666182 51.8903306 7.45498 57.1864506 7.45498 57.1864506 5.11888 51.9182785 5.11888 51.9182785 2.66684364 57.9076418 2.66684364 57.9076418 0.359461818"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    points: "66.9191915 0.359355455 64.5899757 4.13810091 62.149991 0.388428182 59.1830868 0.388428182 63.0647722 6.24374636 59.0443699 12.3011555 61.8725573 12.3011555 64.5068138 8.26288273 67.0855153 12.2724373 69.9416505 12.2724373 66.0316764 6.18595545 69.9137027 0.359355455"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7d788f7c47e41f4a5a92c67bd19e7b8c.svg";
export { ForwardRef as ReactComponent };